import React, { useState } from "react";
import { api } from "@/lib/api";
import { useSite } from "@/contexts/SiteContext";
import { toast } from "sonner";

export default function Contact() {
    const { settings } = useSite();
    const [f, setF] = useState({ name: "", email: "", subject: "", message: "" });
    const [sending, setSending] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setSending(true);
        try {
            await api.post("/contact", f);
            toast.success("Message sent. We'll get back to you.");
            setF({ name: "", email: "", subject: "", message: "" });
        } catch { toast.error("Could not send"); }
        finally { setSending(false); }
    };

    return (
        <div className="max-w-[1100px] mx-auto px-4 md:px-10 py-16 grid md:grid-cols-2 gap-12" data-testid="contact-page">
            <div>
                <div className="font-mono text-[10px] uppercase text-neutral-500">Get in touch</div>
                <h1 className="font-display text-5xl md:text-7xl tracking-tighter mt-1">Talk to us.</h1>
                <p className="mt-6 text-neutral-700">Product question, wholesale, press, or just to hype — we read every message.</p>
                <div className="mt-8 space-y-2 font-mono text-sm">
                    <div><span className="text-neutral-500 uppercase text-[10px]">Email</span><br/>{settings?.contact_email || "hello@clonzo.in"}</div>
                    <div><span className="text-neutral-500 uppercase text-[10px]">Support</span><br/>{settings?.contact_support_email || "returns@clonzo.in"}</div>
                    <div><span className="text-neutral-500 uppercase text-[10px]">Location</span><br/>{settings?.contact_location || "Bengaluru, India"}</div>
                </div>
            </div>
            <form onSubmit={submit} className="border-2 border-black p-6 space-y-4">
                {["name", "email", "subject"].map(k => (
                    <label key={k} className="block">
                        <div className="font-mono text-[10px] uppercase text-neutral-500 mb-1">{k}</div>
                        <input required type={k === "email" ? "email" : "text"} value={f[k]} onChange={e => setF({...f, [k]: e.target.value})} className="w-full border-2 border-black p-3 font-mono text-sm" data-testid={`contact-${k}`} />
                    </label>
                ))}
                <label className="block">
                    <div className="font-mono text-[10px] uppercase text-neutral-500 mb-1">Message</div>
                    <textarea required rows={5} value={f.message} onChange={e => setF({...f, message: e.target.value})} className="w-full border-2 border-black p-3 font-mono text-sm" data-testid="contact-message" />
                </label>
                <button disabled={sending} type="submit" className="w-full bg-black text-white py-3 font-mono uppercase text-xs tracking-widest brutal-shadow" data-testid="contact-submit">{sending ? "Sending…" : "Send Message"}</button>
            </form>
        </div>
    );
}
